export const BP_BOOKING_KEY = 'BalancePayments.BookingInfo';
export const BP_FIRST_DATA_PAYMENT_FORM_KEY = 'BalancePayments.FirstDataPaymentForm';
export const BP_EMAIL_ADDRESS_KEY = 'BalancePayments.EmailAddress'
export const BP_BOOKING_PARAMS = 'BalancePayments.BookingSearchParams'
export const BP_ERROR_KEY = 'BalancePayments.Error'
export const BP_PAYMENT_ERROR_KEY = 'BalancePayments.PaymentError'
export const BP_SUCCESS_KEY = 'BalancePayments.Success'